// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload_pop{padding:0}.upload_pop .avc .avc_title{height:40px;line-height:40px;font-weight:400;color:#282729;background-color:#f5f5f5;font-size:14px;margin-bottom:25px;text-align:center}.upload_pop .avc .img{width:350px;height:105px;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
